import { makeStyles } from "@material-ui/core";

const BasePageStyles = makeStyles(theme => ({
    main: {
        minHeight: "700px",
        height: "100%"
    },
    mainContent: {
        padding: theme.spacing(3, 3)
    },
    demoSection: {
        marginTop: "60px",
        marginBottom: "60px"
    },
    demoH4: {
        color: "#0060A6"
    },
    loginButton: {
        fontWeight: 500
    }
}));

export default BasePageStyles;
